import Layout from "@/app/common-modules/layout/Layout";
/**
 *@author       罗朝军
 *@date         2021/9/11 11:55
 *@Copyright    天源迪科信息技术股份有限公司
 *@Description
 */
const shoppingRouter = [
  {
    path: "",
    component: Layout,
    redirect: "",
    children: [
      {
        path: "",
        component: () => import("@/app/shop/views/shopping.vue"),
        meta: {
          isShowShopHead: true,
          isShowPageFooter: true //是否展示页脚
        },
        name: "shopping"
      },
      {
        path: "/procurementBidding",
        component: () => import("@/app/shop/views/procurementBidding.vue"),
        meta: {
          isShowShopHead: true,
          isShowPageFooter: true //是否展示页脚
        },
        name: "procurementBidding"
      },
      {
        path: "/procurementBiddingList",
        component: () => import("@/app/shop/views/procurementBiddingList.vue"),
        meta: {
          isShowShopHead: true,
          isShowPageFooter: true //是否展示页脚
        },
        name: "procurementBidding"
      },
      {
        path: "/noticeDetail",
        component: () => import("@/app/shop/views/viewNoticeDetail.vue"),
        meta: {
          isShowShopHead: true,
          isShowPageFooter: true //是否展示页脚
        },
        name: "noticeDetail"
      },
      {
        path: "/operationManual",
        component: () => import("@/app/shop/views/operationManual.vue"),
        meta: {
          isShowShopHead: true,
          isShowPageFooter: true //是否展示页脚
        },
        name: "operationManual"
      },
      {
        path: "/question",
        component: () => import("@/app/shop/views/question.vue"),
        meta: {
          isShowShopHead: true,
          isShowPageFooter: true //是否展示页脚
        },
        name: "question"
      },
      {
        path: "/viewMore",
        component: () => import("@/app/shop/views/viewMore.vue"),
        meta: {
          isShowShopHead: true,
          isShowPageFooter: true //是否展示页脚
        },
        name: "viewMore"
      },
      {
        path: "/questionOrManualDetail",
        component: () => import("@/app/shop/views/questionOrManualDetail.vue"),
        meta: {
          isShowShopHead: true,
          isShowPageFooter: true //是否展示页脚
        },
        name: "questionOrManualDetail"
      },
      {
        path: "/announcementsList",
        component: () => import("@/app/shop/views/announcementsList.vue"),
        meta: {
          isShowShopHead: true,
          isShowPageFooter: true //是否展示页脚
        },
        name: "announcementsList"
      },
      {
        path: "/announcementsListNew",
        component: () => import("@/app/shop/views/announcementsListNew.vue"),
        meta: {
          isShowShopHead: true,
          isShowPageFooter: true //是否展示页脚
        },
        name: "announcementsListNew"
      },
      {
        path: "/announcementDetail",
        component: () => import("@/app/shop/views/announcementDetail.vue"),
        meta: {
          isShowShopHead: true,
          isShowPageFooter: true //是否展示页脚
        },
        name: "announcementDetail"
      },
      {
        path: "/announcementDetailNew",
        component: () => import("@/app/shop/views/announcementDetailNew.vue"),
        meta: {
          isShowShopHead: true,
          isShowPageFooter: true //是否展示页脚
        },
        name: "announcementDetailNew"
      },
      {
        path: "/plateTitle",
        component: () => import("@/app/shop/views/plateTitle.vue"),
        meta: {
          isShowShopHead: true,
          isShowPageFooter: true //是否展示页脚
        },
        name: "plateTitle"
      },
      {
        path: "/postingAdd",
        component: () => import("@/app/shop/views/postingAdd.vue"),
        meta: {
          isShowShopHead: true,
          isShowPageFooter: true //是否展示页脚
        },
        name: "postingAdd"
      },
      {
        path: "/themeDetails",
        component: () => import("@/app/shop/views/themeDetails.vue"),
        meta: {
          isShowShopHead: true,
          isShowPageFooter: true //是否展示页脚
        },
        name: "themeDetails"
      },
      {
        path: "/topicReply",
        component: () => import("@/app/shop/views/topicReply.vue"),
        meta: {
          isShowShopHead: true,
          isShowPageFooter: true //是否展示页脚
        },
        name: "topicReply"
      },
      {
        path: "/searchList",
        component: () => import("@/app/shop/views/searchList.vue"),
        meta: {
          isShowShopHead: true,
          isShowPageFooter: true //是否展示页脚
        },
        name: "searchList"
      }
    ]
  }
];

export default shoppingRouter;
